import React, {useEffect, useRef, useState} from 'react';
import {Spin} from 'antd';
import {MailOutlined} from '@ant-design/icons';

import MassEmailForm from '../../../components/admin/MassEmailForm';
import PageTitle from '../../../components/page/PageTitle';
import MassEmailPreview from '../../../components/admin/MassEmailPreview';
import StepsWrapper from '../../../components/StepsWrapper';
import ErrorBoundary from '../../../components/ErrorBoundary';
import {getMassEmailCount, sendMassEmail} from '../../../helpers/contact';
import {messageType, showMessages} from '../../../helpers/message';

const MassEmail = () => {
    const abortControllerRef = useRef(new AbortController());
    const abortSignalRef = useRef(abortControllerRef.current.signal);

    const [subject, setSubject] = useState(null);
    const [body, setBody] = useState(null);
    const [loading, setLoading] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);
    const [massEmailCount, setMassEmailCount] = useState(0);

    useEffect(() => {
        const abortController = abortControllerRef.current;
        return function abort() {
            abortController.abort();
        }
    }, []);

    useEffect(() => {
        const onGetMassEmailCount = async () => {
            setLoading(true);
            const abortSignal = abortSignalRef.current;

            try {
                let response = await getMassEmailCount(abortSignal);
                if (response) {
                    setMassEmailCount(response['count']);
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                showMessages(error.message, messageType.error);
            }
        }
        onGetMassEmailCount();
    }, []);

    const goNext = () => {
        setCurrentStep(currentStep + 1);
    }

    const goBack = (e) => {
        e.preventDefault();

        setCurrentStep(currentStep - 1);
    }

    const onSendMassEmail = async () => {
        setLoading(true);
        const abortSignal = abortSignalRef.current;

        try {
            let email = {
                'subject': subject,
                'body': body
            }
            await sendMassEmail(email, abortSignal);
            setLoading(false);
            showMessages(massEmailCount + ` emails are being sent!`, messageType.success);

            // Clear data and go to step 1 after submission.
            setSubject(null);
            setBody(null);
            setCurrentStep(0);
        } catch (error) {
            setLoading(false);
            showMessages(error.message, messageType.error);
        }
    }

    const steps = [
        {
            title: 'Mass Email Form',
            content:
                <MassEmailForm
                    subject={subject}
                    setSubject={setSubject}
                    body={body}
                    setBody={setBody}
                    handleFinish={goNext}
                />,
            form: 'mass-email-card-form'
        },
        {
            title: 'Mass Email Preview',
            content:
                <MassEmailPreview
                    subject={subject}
                    body={body}
                    massEmailCount={massEmailCount}
                />
        }
    ];

    return (
        <Spin spinning={loading}>
            <PageTitle title="Mass Email" icon={<MailOutlined/>}/>
            <ErrorBoundary>
                <StepsWrapper
                    currentStep={currentStep}
                    goBack={goBack}
                    steps={steps}
                    isLoading={loading}
                    handleFinish={onSendMassEmail}
                    submitText="Send"
                />
            </ErrorBoundary>
        </Spin>
    );
}

MassEmail.propTypes = {};

export default MassEmail;